import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/views/index'
import music from '@/views/index/music'
import my from '@/views/index/my'
import list from '@/views/index/list'
import system from '@/views/index/system'
import exterior from '@/views/exterior'

Vue.use(VueRouter)

//获取原型对象上的push函数
// const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法，replace方法就把VueRouter.prototype.push的push换成replace即可
// VueRouter.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }

// 注册路由信息
const routes = [{
        path: '/',
        component: index,
        redirect: '/index/music',
        meta: {
            title: '首页'
        }
    },
    {
        path: '/exterior',
        component: exterior,
    },
    {
        path: '/index',
        component: index,
        redirect: '/index/music',
        meta: {
            title: '首页'
        },
        children: [{
                path: 'music',
                component: music,
                meta: {
                    title: '音乐赏析'
                }
            },
            {
                path: 'list',
                component: list,
                meta: {
                    title: '更多歌曲'
                }
            },
            {
                path: 'my',
                component: my,
                meta: {
                    title: '联系我们'
                }
            },
            {
                path: 'system',
                component: system,
                meta: {
                    title: '自审制度'
                }
            }
        ]
    }
]
const router = new VueRouter({
    routes
})

export default router